import { getDomainName } from "project-config/utils/domain";

function objectToCookie(obj) {
  const cookieString = Object.keys(obj)
    .map((key) => {
      return `${key}=${obj[key]}`;
    })
    .join(";");
  return `${cookieString};path=/`;
}

function cookiesToObject() {
  var cookies = {};
  if (document.cookie) {
    var cookieArray = document.cookie.split(";");
    for (var i = 0; i < cookieArray.length; i++) {
      var cookie = cookieArray[i].trim().split("=");
      cookies[cookie[0]] = cookie[1];
    }
  }
  return cookies;
}

function isDev() {
  return location.host.includes("127.0.0.1");
}

class Cookie {
  constructor(name, expirationDays) {
    this.name = name;
    this.expirationDays = expirationDays;
  }

  setCookie(name, value, Days = 356, isSubDomain = false) {
    const date = new Date().setDate(new Date().getDate() + Days);
    document.cookie = `${name}=${value};expires=${date};${
      isSubDomain ? document.domain : `domain=.${getDomainName(2)}.com;`
    }path=/`;
  }

  set(key, value, isSubDomain = false) {
    const cookieValue = this.getCookieValue();
    cookieValue[key] = value;
    cookieValue["domain"] = isSubDomain
      ? document.domain
      : `domain=.${getDomainName(2)}.com;`;
    const cookieString = objectToCookie(cookieValue);
    document.cookie = cookieString;
  }

  getLocal(key) {
    const obj = cookiesToObject(document.cookie);
    return obj[key];
  }

  setLocal(key, value, isSubDomain = false) {
    const obj = cookiesToObject(document.cookie);
    obj[key] = value;
    obj["domain"] = isSubDomain
      ? document.domain
      : `domain=.${getDomainName(2)}.com;`;
    const cookie = objectToCookie(obj);
    document.cookie = cookie;
  }

  get(key) {
    const cookieValue = this.getCookieValue();
    return cookieValue[key];
  }

  delete(key) {
    const cookieValue = this.getCookieValue();
    delete cookieValue[key];
    const cookieString = objectToCookie(cookieValue);
    document.cookie = cookieString;
  }

  getCookieValue() {
    const decodedCookie = document.cookie;
    const cookieArray = decodedCookie.split(";");
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(this.name) === 0) {
        const cookieValueString = cookie.substring(
          this.name.length + 1,
          cookie.length
        );
        return JSON.parse(cookieValueString);
      }
    }
    return {};
  }

  getExpirationDate() {
    const date = new Date();
    date.setTime(date.getTime() + this.expirationDays * 24 * 60 * 60 * 1000);
    return date.toUTCString();
  }
}

const CookieHelper = new Cookie("cookie", 1);

export { CookieHelper };
